import { CHECKOUT_FETCH_REQUEST, CHECKOUT_FETCH_SUCCESS, CHECKOUT_FETCH_FAILURE } from './types';

const initialState = {
    loading: false,
    checkout: {},
    error: ''
}

const checkout = (state = initialState, action) => {
    switch (action.type) {
        case CHECKOUT_FETCH_REQUEST:
            return {
                loading: true,
                checkout: {},
                error: '',
            }
        case CHECKOUT_FETCH_SUCCESS:
            return {
                loading: false,
                checkout: action.payload,
                error: ''
            }
        case CHECKOUT_FETCH_FAILURE:
            return {
                loading: false,
                checkout: {},
                error: action.payload
            }
        default:
            return state
    }
}

export default checkout;